<template>
    <div v-if="c_data">
    <div v-if="show_info">
        <RowComponent
            :hide_label="true"
        >
        <div class="d-flex body-1">
        <div class="d-flex font-italic">Verificazione periodica in seguito a: </div>
        <div class="d-flex ml-2" v-switch="c_data.cause">
            <span v-case="`expire`">scadenza validità verificazione periodica</span>
            <span v-case="`repair`">riparazione effettuata da {{c_data.repairer}}</span>
            <span v-case="`other`">{{c_data.other}}</span>
        </div>
        </div>
        </RowComponent>
    </div>
    <BasicCard v-else :title="'Verificazione periodica in seguito a'">
        <v-form v-model="valid.object">
            <div class="d-flex ma-2 flex-column" >
                <v-radio-group dense class="my-0 py-0" v-model="c_data.cause">
                    <v-radio dense label="scadenza validità verificazione periodica precedente" value="expire"></v-radio>
                    <v-radio dense label="riparazione" value="repair"></v-radio>
                    <v-radio dense label="altro" value="other"></v-radio>
                </v-radio-group>
                <v-text-field dense outlined
                    class="ml-2"
                    v-if="c_data.cause == 'repair'"
                    label="riparazione effettuata da"
                    v-model="c_data.repairer"
                ></v-text-field>
                <v-text-field dense outlined
                    class="ml-2"
                    v-if="c_data.cause == 'other'"
                    label="specificare altro"
                    v-model="c_data.other"
                ></v-text-field>
            </div>
        </v-form>
   </BasicCard>
    </div>
</template>
<script>
import BasicCard from '../../../components/utils/Basic_card'
import RowComponent from '../../../components/utils/RowComponent.vue'
import {CustomDataMixin} from "../../../utils/CustomDataMixin.js"
import {getModel} from '../../../utils/model'
// import _ from 'lodash'

export default {
    mixins: [CustomDataMixin],
    components: {RowComponent, BasicCard},
    data() {
        return {
            valid: {
                object: false,
                metro: false
            }
        }
    },
    mounted() {
        let model = null
        model = getModel('LegCustomData')
        if (model) {
            this.c_data = model(this.o_data)
        } else {
            this.c_data = _.cloneDeep(this.o_data)
        }
    }
}
</script>